export default {
  data() {
    return {
      progress: 0,
      reader: {}
    };
  },
  methods: {
    toBase64(file) {
      return new Promise((resolve, reject) => {
        this.reader = new FileReader();
        this.reader.readAsDataURL(file);
        this.reader.onload = () => resolve(this.reader.result);
        this.reader.onerror = error => reject(error);
        this.reader.onprogress = e => {
          if (e.lengthComputable) {
            setTimeout(() => {
              this.progress = Math.round((e.loaded * 100) / e.total);
            }, 200);
          }
        };
      });
    },
    abortConvertBase64() {
      this.reader.abort();
    }
  }
};
